import { useEffect, useState } from 'react'
import ApiClientSingleton from '../../utils/helpers/ApiClientSingleton'

const usePostKycQrCode = ({ runOnMount = false } = {}) => {
  const [isLoading, setIsLoading] = useState(!!runOnMount)
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)

  const getItems = async () => {
    setIsLoading(true)
    setError(null)
    const apiClient = ApiClientSingleton.get()

    try {
      const { data } = await apiClient.kyc.qrcode()

      setResult(data)
    } catch (err) {
      if (err.response?.data) {
        setError(err.response.data)
      } else {
        setError(err.message)
      }
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (runOnMount) {
      getItems()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runOnMount])

  return {
    error,
    isLoading,
    request: getItems,
    result,
  }
}

export default usePostKycQrCode
